export default __webpack_public_path__ + "static/media/scroll-down.d799a4d6.svg";